// AuthorizationScreen
export const AUTHORIZATION_SCREEN_HEADER = 'Authorization is required';
export const AUTHORIZATION_SCREEN_DESC =
  'Please enter your PIN code to access the sales app';
export const AUTHORIZATION_SCREEN_WARNING =
  'If you encounter issues please reach out to your system administrator.';
